
export const getCourses = ({ courseReducer: { courses = [] } = {} }) => courses;
export const getCourseFilter = ({ courseReducer: { filter = {} } = {} }) => filter;
export const getCoursesCount = ({ courseReducer: { count = 0 } = {} }) => count;
export const getCommonFilter = ({ courseReducer: { common_filter = {} } = {} }) => common_filter;
export const getScheduleEventReviewDetails = ({ courseReducer: { scheduleEventsReview = {} } = {}, }) => scheduleEventsReview;